module.exports = __webpack_public_path__ + "img/pic_hetong.45c2b057.png";